import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const MaintenanceIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M22.19.14l-1.36,1.36-.64,1.27-6.42,6.42-2.14-2.15c.39-1.95-.2-3.91-1.6-5.32C8.72.4,6.82-.22,4.96.07c-.38.06-.7.31-.81.69-.12.36-.03.76.24,1.03l1.49,1.49c.72.72.82,1.83.23,2.56-.34.41-.81.65-1.34.68-.53,0-1.03-.17-1.39-.54l-1.59-1.58c-.27-.27-.67-.36-1.03-.25-.36.12-.63.44-.69.82-.3,1.85.32,3.75,1.64,5.07,1.4,1.41,3.37,1.99,5.32,1.6l.88.87L1,19.41C0,20.41,0,22.01,1,22.99c.48.49,1.12.74,1.8.74s1.31-.26,1.79-.74l8.47-8.47-1.27-1.27L21.24,3.81l1.27-.63,1.37-1.37-1.68-1.67ZM10.74,12.22l-1.27-1.27-.68.68-1.38-1.36-.34.09c-1.62.43-3.3-.02-4.48-1.19-.94-.94-1.42-2.23-1.35-3.55l1.25,1.25c.61.62,1.47.95,2.33.9.87-.04,1.68-.45,2.24-1.13.99-1.2.86-3.06-.31-4.22l-1.16-1.16c1.32-.06,2.62.41,3.55,1.35,1.17,1.17,1.62,2.85,1.19,4.48l-.09.34,2.65,2.64-2.17,2.16Z"
            fill="currentColor"
         />
         <path
            d="M13.33,16.17l6.01,6.01c.43.43,1.02.64,1.62.58.61-.06,1.14-.38,1.48-.9.53-.79.38-1.88-.34-2.6l-7.2-7.2.88-.88,7.2,7.2c1.14,1.14,1.35,2.9.5,4.17-.55.82-1.42,1.34-2.39,1.44-.11.01-.22.02-.33.02-.86,0-1.68-.34-2.3-.95l-6.01-6.01.88-.88Z"
            fill="currentColor"
         />
         <circle
            cx="20.16"
            cy="20.31"
            r="1"
            fill="currentColor"
         />
      </svg>
   )
}

export default MaintenanceIcon
